var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 2C9.31098 2 8.06127 2.81055 7.43253 4H6.75C4.67894 4 3 5.67894 3 7.75V18.25C3 20.3211 4.67894 22 6.75 22H17.25C19.3211 22 21 20.3211 21 18.25V7.75C21 5.67894 19.3211 4 17.25 4H16.5675C15.9387 2.81055 14.6891 2 13.25 2H10.75ZM4.5 7.75C4.5 6.50736 5.50736 5.5 6.75 5.5H7.0082C7.00276 5.58263 7 5.66599 7 5.75V6.25C7 7.21649 7.78351 8 8.75 8H15.25C16.2165 8 17 7.21648 17 6.25V5.75C17 5.66599 16.9972 5.58263 16.9918 5.5H17.25C18.4927 5.5 19.5 6.50736 19.5 7.75V18.25C19.5 19.4927 18.4927 20.5 17.25 20.5H6.75C5.50736 20.5 4.5 19.4927 4.5 18.25V7.75ZM8.5 5.75C8.5 4.50736 9.50736 3.5 10.75 3.5H13.25C14.4927 3.5 15.5 4.50736 15.5 5.75V6.25C15.5 6.38808 15.3881 6.5 15.25 6.5H8.75C8.61193 6.5 8.5 6.38807 8.5 6.25V5.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard2);
export default __webpack_public_path__ + "static/media/clipboard-2.fe07e1f631002fc355746e3ac179891d.svg";
export { ForwardRef as ReactComponent };